// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"userItem_wrapper_3xtDvBS","actions":"userItem_actions_LRydA7s","adminLabel":"userItem_adminLabel_2jFJBzN","button":"userItem_button_2EQ9fmk"};